(() => {
  const selector = '[data-dna-cocktail-carousel]';
  if (window.DNACocktailCarousel) {
    window.DNACocktailCarousel.mount(document);
    return;
  }

  const controllers = new Map();
  const elementsWithin = root => Array.from(root.querySelectorAll(selector));

  const prepare = element => {
    if (controllers.has(element)) return;
    // Give these below-the-fold images the same head start as the carousel.
    element.querySelectorAll('img[data-src], img[data-srcset]').forEach(image => {
      image.dataset.expand = '1000';
    });
    let observer;
    let instance;
    let started = false;

    const stopWaiting = () => {
      if (observer) observer.disconnect();
      element.removeEventListener('focusin', start, true);
      element.removeEventListener('pointerenter', start);
      element.removeEventListener('pointerdown', start, true);
      element.removeEventListener('touchstart', start, true);
    };

    function start() {
      if (started || !element.isConnected) return;
      started = true;
      stopWaiting();
      if (element.swiper) {
        element.dataset.dnaCarouselState = 'ready';
        return;
      }
      const settings = element.dataset;
      const params = {
        slidesPerView: Number(settings.dnaMobileItems),
        spaceBetween: Number(settings.dnaMobileGap),
        breakpoints: {
          450: { slidesPerView: Number(settings.dnaTabletItems), spaceBetween: Number(settings.dnaMobileGap) },
          1024: { slidesPerView: Number(settings.dnaDesktopItems), spaceBetween: Number(settings.dnaDesktopGap) }
        }
      };
      if (settings.dnaPagination === 'true') {
        params.pagination = {
          el: element.querySelector('.swiper-pagination'),
          clickable: true,
          renderBullet: (index, className) => '<span class="' + className + '"></span>'
        };
      }
      if (settings.dnaAutoplay === 'true') {
        params.autoplay = { delay: Number(settings.dnaDelay), disableOnInteraction: false };
      }
      element.dataset.dnaCarouselState = 'starting';
      try {
        instance = new window.Swiper(element, params);
        element.dataset.dnaCarouselState = 'ready';
      } catch (error) {
        if (element.swiper && !element.swiper.destroyed) element.swiper.destroy(true, true);
        element.dataset.dnaCarouselState = 'fallback';
        console.warn('DNA cocktail carousel could not initialize.', error);
      }
    }

    controllers.set(element, {
      start,
      destroy() {
        stopWaiting();
        if (instance && !instance.destroyed) instance.destroy(true, true);
        controllers.delete(element);
      }
    });
    element.addEventListener('focusin', start, true);
    element.addEventListener('pointerenter', start, { passive: true });
    element.addEventListener('pointerdown', start, { capture: true, passive: true });
    element.addEventListener('touchstart', start, { capture: true, passive: true });
    if (!('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      start();
    } else {
      observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) start();
      }, { rootMargin: '1000px 0px', threshold: 0 });
      observer.observe(element);
    }
  };

  const mount = root => elementsWithin(root).forEach(prepare);
  window.DNACocktailCarousel = { mount };
  document.addEventListener('shopify:section:load', event => mount(event.target));
  document.addEventListener('shopify:section:unload', event => {
    elementsWithin(event.target).forEach(element => controllers.get(element)?.destroy());
  });
  document.addEventListener('shopify:section:select', event => {
    elementsWithin(event.target).forEach(element => controllers.get(element)?.start());
  });
  window.addEventListener('pageshow', () => {
    controllers.forEach((controller, element) => {
      const rect = element.getBoundingClientRect();
      if (rect.top <= window.innerHeight + 1000 && rect.bottom >= -1000) controller.start();
    });
  });
  mount(document);
})();
